import { ComponentProps } from "react";

const TriangleDownIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.89082 9L0.961875 0.749999L10.8198 0.75L5.89082 9Z" fill="currentColor" />
    </svg>
  );
};

export default TriangleDownIcon;
